exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".accent--text{color:rgba(0,0,0,.54)!important}.genepanelsRect{fill:#4e7ad3;pointer-events:all}.genepanelsRect,.grayRect{stroke:#fff;stroke-width:2}.grayRect{fill:#e8ebed}.Rightbar_card_divider{margin-top:10px;margin-bottom:10px}.v-list__tile__sub-title,.v-list__tile__title{white-space:normal;overflow:initial;text-overflow:clip}.v-list__tile{height:auto}.conditionsBox{width:470px;overflow-wrap:break-word;height:370px;overflow-y:scroll}div.tooltip{position:absolute;text-align:center;z-index:20;color:#fff;padding:4px 6px;font:11px arial;background:#505050;border:0;border-radius:4px;pointer-events:none}.input-group__input{min-height:3px}.headerWidth{width:1%;color:red}#geneSearchBox .v-label{font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ce40bfbc","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/app/components/pages/ShowGenePanel.vue
// module id = 445
// module chunks = 0